(() => {
  const FRAG = `
precision highp float;
uniform vec2 uRes;
uniform float uTime;
uniform vec2 uMouse;
uniform float uScroll;
varying vec2 vUv;
float hash(vec2 p){ p = fract(p*vec2(123.34, 456.21)); p += dot(p, p+45.32); return fract(p.x*p.y); }
float height(vec2 p, float t){
  vec2 q = p;
  q += 0.55 * vec2(sin(q.y * 0.9 + t * 0.7), cos(q.x * 0.7 - t * 0.5));
  q += 0.35 * vec2(sin(q.y * 1.6 - t * 0.4 + 1.3), cos(q.x * 1.3 + t * 0.6 + 2.1));
  float h = sin(q.x * 1.15 + q.y * 0.55);
  h += 0.55 * sin(q.x * -0.6 + q.y * 1.35 + 1.7);
  h += 0.22 * sin(q.x * 2.3 + q.y * 1.9 - t * 0.3);
  return h;
}
void main(){
  vec2 uv = vUv;
  float asp = uRes.x / uRes.y;
  vec2 p = vec2(uv.x * asp, uv.y) * 3.1;
  p = mat2(0.86, -0.5, 0.5, 0.86) * p;
  p.y -= uScroll * 2.6;
  float t = uTime * 0.16;
  float e = 0.012;
  float h  = height(p, t);
  float hx = height(p + vec2(e, 0.0), t);
  float hy = height(p + vec2(0.0, e), t);
  vec3 n = normalize(vec3(-(hx - h) / e * 0.75, -(hy - h) / e * 0.75, 1.0));
  vec2 m = vec2(uMouse.x * asp, uMouse.y);
  vec3 L = normalize(vec3((m.x - uv.x * asp) * 0.9 + 0.35, (m.y - uv.y) * 0.9 + 0.55, 0.85));
  vec3 V = vec3(0.0, 0.0, 1.0);
  vec3 H = normalize(L + V);
  float diff = clamp(dot(n, L), 0.0, 1.0);
  float spec = pow(clamp(dot(n, H), 0.0, 1.0), 56.0);
  float sheen = pow(clamp(dot(n, H), 0.0, 1.0), 5.0);
  float drift = 0.5 + 0.5 * sin(uScroll * 4.0 + uv.x * 1.4 - 0.4);
  vec3 walnut = vec3(0.105, 0.062, 0.036);
  vec3 cocoa  = vec3(0.235, 0.135, 0.078);
  vec3 copper = vec3(0.42, 0.205, 0.12);
  vec3 rose   = vec3(0.93, 0.62, 0.47);
  vec3 cream  = vec3(1.0, 0.91, 0.80);
  vec3 base = mix(walnut, cocoa, smoothstep(-1.4, 1.2, h));
  base = mix(base, copper, smoothstep(0.35, 1.0, drift) * smoothstep(-0.2, 1.4, h) * 0.8);
  vec3 col = base * (0.22 + 0.62 * diff * diff);
  vec3 L2 = normalize(vec3(-0.75, -0.6, 0.55));
  vec3 H2 = normalize(L2 + V);
  float spec2 = pow(clamp(dot(n, H2), 0.0, 1.0), 22.0);
  vec3 ember = mix(vec3(0.86, 0.31, 0.0), vec3(0.95, 0.45, 0.35), 0.5 + 0.5 * sin(uScroll * 5.0 + 1.0));
  col += ember * spec2 * (0.16 + 0.14 * drift);
  col += vec3(0.75, 0.42, 0.30) * pow(1.0 - clamp(n.z, 0.0, 1.0), 2.0) * 0.18;
  col += rose * sheen * 0.07;
  col += mix(rose, cream, 0.35) * spec * 0.55;
  float vig = smoothstep(1.3, 0.2, length((uv - vec2(0.5, 0.55)) * vec2(asp * 0.75, 1.0)));
  col *= 0.55 + 0.45 * vig;
  col += (hash(uv * uRes + fract(uTime)) - 0.5) * 0.02;
  gl_FragColor = vec4(col, 1.0);
}`;
  const VERT = `attribute vec2 a; varying vec2 vUv; void main(){ vUv = a*0.5+0.5; gl_Position = vec4(a,0.0,1.0); }`;
  const canvas = document.querySelector('[data-silk]');
  if (!canvas) return;
  const gl = canvas.getContext('webgl', { antialias: false, alpha: false, powerPreference: 'low-power' });
  if (!gl) { canvas.remove(); return; }
  const sh = (type, src) => { const s = gl.createShader(type); gl.shaderSource(s, src); gl.compileShader(s); return s; };
  const pr = gl.createProgram();
  gl.attachShader(pr, sh(gl.VERTEX_SHADER, VERT)); gl.attachShader(pr, sh(gl.FRAGMENT_SHADER, FRAG));
  gl.linkProgram(pr);
  if (!gl.getProgramParameter(pr, gl.LINK_STATUS)) { canvas.remove(); return; }
  gl.useProgram(pr);
  const buf = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, buf);
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1,-1,1,-1,-1,1,1,1]), gl.STATIC_DRAW);
  const loc = gl.getAttribLocation(pr, 'a'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
  const U = (n) => gl.getUniformLocation(pr, n);
  const uRes = U('uRes'), uTime = U('uTime'), uMouse = U('uMouse'), uScroll = U('uScroll');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const scale = Math.min(window.devicePixelRatio || 1, 2) * (innerWidth < 760 ? 0.38 : 0.5);
  /* Groesse aus der CSS-Box (100lvh): bleibt gleich, wenn am Handy die Browserleiste ein- und ausfaehrt.
     Sonst wird die Leinwand dabei geleert und bleibt waehrend des Wischens leer (Flackern beim Hochscrollen). */
  let drawNow = null;
  const resize = () => {
    const bw = canvas.clientWidth || innerWidth, bh = canvas.clientHeight || innerHeight;
    const w = Math.max(1, Math.round(bw * scale)), h = Math.max(1, Math.round(bh * scale));
    if (canvas.width !== w || canvas.height !== h) {
      canvas.width = w; canvas.height = h; gl.viewport(0, 0, w, h);
      if (drawNow) drawNow();
    }
  };
  resize(); addEventListener('resize', resize, { passive: true });
  let mx = 0.7, my = 0.75, tx = mx, ty = my, sc = 0, scT = 0;
  addEventListener('pointermove', (e) => { tx = e.clientX / innerWidth; ty = 1 - e.clientY / innerHeight; }, { passive: true });
  /* Handy: waehrend des Wischens nicht neu rechnen, damit Film und Scrollen die Grafik fuer sich haben */
  const touch = matchMedia('(hover: none) and (pointer: coarse)').matches;
  let lastScroll = 0;
  /* Seitenhoehe nur bei Groessenaenderung lesen, nicht bei jedem Scroll-Ereignis (erzwingt sonst ein Layout) */
  let maxScroll = 1;
  const readMax = () => { maxScroll = Math.max(1, document.documentElement.scrollHeight - innerHeight); };
  readMax();
  new ResizeObserver(readMax).observe(document.documentElement);
  /* im Scroll-Ereignis nichts aus dem Layout lesen, die Position holt sich das naechste Bild */
  let scrollSeen = true;
  const readScroll = () => { scrollSeen = false; lastScroll = performance.now(); };
  addEventListener('scroll', readScroll, { passive: true }); scT = scrollY / maxScroll; sc = scT;
  const t0 = performance.now() - (window.__silkT || 12000);
  let last = 0, raf = 0, running = true;
  const paint = (now) => {
    gl.uniform2f(uRes, canvas.width, canvas.height);
    gl.uniform1f(uTime, reduce ? 12 : (now - t0) / 1000);
    gl.uniform2f(uMouse, mx, my);
    gl.uniform1f(uScroll, sc);
    gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
  };
  drawNow = () => paint(performance.now());
  const frame = (now) => {
    raf = requestAnimationFrame(frame);
    if (now - last < 33) return;
    if (touch && now - lastScroll < 220) return;
    last = now;
    if (!scrollSeen) { scT = scrollY / maxScroll; scrollSeen = true; }
    mx += (tx - mx) * 0.04; my += (ty - my) * 0.04; sc += (scT - sc) * 0.06;
    paint(now);
    if (reduce) { cancelAnimationFrame(raf); running = false; }
  };
  raf = requestAnimationFrame(frame);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) { cancelAnimationFrame(raf); running = false; }
    else if (!running) { running = true; raf = requestAnimationFrame(frame); }
  });
  if (reduce) { addEventListener('scroll', () => { if (!running) { running = true; raf = requestAnimationFrame(frame); } }, { passive: true }); }
  canvas.classList.add('is-on');
})();
